import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DateTimePicker, Localization } from "react-widgets";
import {
  DateLocalizer,
  NumberLocalizer,
} from "react-widgets/IntlLocalizer";

const parseDateTime = (value) => {
  const match = value
    .trim()
    .match(/^(\d{1,2})[./](\d{1,2})[./](\d{2}|\d{4}),?\s+(\d{1,2}):(\d{2})$/);
  if (!match) return undefined;

  const [, dayText, monthText, yearText, hourText, minuteText] = match;
  const day = Number(dayText);
  const month = Number(monthText);
  const year = Number(yearText) + (yearText.length === 2 ? 2000 : 0);
  const hour = Number(hourText);
  const minute = Number(minuteText);
  const parsed = new Date(year, month - 1, day, hour, minute);

  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day ||
    parsed.getHours() !== hour ||
    parsed.getMinutes() !== minute
  ) {
    return undefined;
  }

  return parsed;
};

const LocalizedDateTimePicker = (props) => {
  const { i18n, t } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split(
    "-",
  )[0];
  const isGerman = language === "de";
  const culture = isGerman ? "de-DE" : "en-GB";

  const dateLocalizer = useMemo(
    () => new DateLocalizer({ culture, firstOfWeek: 1 }),
    [culture],
  );
  const numberLocalizer = useMemo(
    () => new NumberLocalizer({ culture }),
    [culture],
  );
  const messages = {
    moveToday: t("allgemein.zeitraumfilter.heute"),
    moveBack: t("allgemein.zurueck"),
    moveForward: t("allgemein.weiter"),
    dateButton: t("allgemein.Datum"),
  };
  const formats = useMemo(
    () => ({
      datetime: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      },
      time: {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      },
      header: { month: "long", year: "numeric" },
      weekday: { weekday: "short" },
      month: { month: "long" },
    }),
    [],
  );

  return (
    <Localization
      date={dateLocalizer}
      number={numberLocalizer}
      messages={messages}
    >
      <DateTimePicker
        {...props}
        formats={formats}
        messages={messages}
        parse={props.parse || parseDateTime}
        timeInputProps={{
          ...props.timeInputProps,
          use12HourClock: false,
        }}
      />
    </Localization>
  );
};

export default LocalizedDateTimePicker;
